import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

const LoginPage = () => (
  <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'center', position: 'relative', width: '100vw' }}>
    <div style={{ fontSize: '30px', marginBottom: '10px', textTransform: 'uppercase' }}>
      Welcome to your tribe
    </div>
    <Button
      onClick={() => {
        window.location.href = '/auth/google';
      }}
      size="large"
      type="primary"
    >
      SIGN IN
    </Button>
    <div
      style={{
        bottom: '24px',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: '13px',
        lineHeight: 1.6,
        position: 'absolute',
        textAlign: 'center',
        width: '100%',
      }}
    >
      <div>
        <Link to="/privacy">Privacy Policy</Link>
        {' · '}
        <Link to="/terms">Terms of Use</Link>
      </div>
    </div>
  </div>
);

export default LoginPage;
